// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';

//Services
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';

//Classes
import { FormAction } from "../../shared/classes/formAction";

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// HealthCheckComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.hc-title-div{margin:10px 8px 15px 8px;border-bottom:solid 1px #ccc}.hc-grid-div{margin:0 8px}.hc-grid{border-style:solid;border-width:1px 1px 0 1px;border-color:#ccc}.hc-grid-columnHeaderRow{background-color:#efefef !important}'],
    template : '<div data-test-id="content_health_check"></div>\n\n<!--Title-->\n<h2 class="hc-title-div">\n    CPDES Health Check\n</h2>\n\n<!--Grid-->\n<div class="hc-grid-div">\n    <cas-grid [settings]="_gridSettings" summary="CPDES Health Check" (onRefreshClicked)="gridRefreshClicked()"></cas-grid>\n</div>\n\n<!--Popup-->\n<!--====================================================================================================-->\n<!--POPUP INSTANCE CONTAINER-->\n<div id="health_check_page_popups"></div>\n\n<!--====================-->\n<!-- To Email Address -->\n<!--====================-->\n<modal #addToEmailPopup\n       containerId="health_check_page_popups"\n       title="Heath Check Test Email Address"\n       label="addToEmailPopup">\n\n    <!--FVT-ID-->\n    <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_test_email"></section>\n\n    <!-- body -->\n    <section>\n        <form #emailAddressForm="ngForm">\n\n            <div class="form-group">\n                <label>Enter email address for test email. If left blank will default to test email address in config.</label><br /><br />\n                <label for="email_address" style="font-weight:bold;">Email&nbsp;Address:</label>\n                <input #email_address="ngModel"\n                       id="email_address"\n                       name="email_address"\n                       class="form-control"\n                       type="email"\n                       aria-label="Email Address"\n                       [(ngModel)]="_toEmailAddress">\n            </div>\n            <div *ngIf="email_address.dirty || email_address.touched">\n                <div *ngIf="!emailAddressValid()" class="alert alert-danger">\n                    Please enter valid email address.\n                </div>\n            </div>\n        </form>\n\n    </section>\n\n    <!-- footer -->\n    <footer>\n        <button id="email_cancel" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n        <button id="email_send" accesskey="s" type="button" class="btn btn-primary" (click)="sendButtonClicked()">Send Email</button>\n    </footer>\n</modal>\n',
    providers:[],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class HealthCheckComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('addToEmailPopup') addToEmailPopup;

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _loading = true;
    _gridSettings = {
        loading:true,
        //rowsPerPage:10,
        disableSelection:true,
        hideClearSelectedButton:true,
        hidePaginationControls:true,
        cssClasses_Grid:"hc-grid",
        cssClasses_ColumnHeaderRow:"hc-grid-columnHeaderRow",
        columns:[
            { fieldName:'name', display:'Name', width:'10%', minWidth:90 },
            { fieldName:'status', display:'', width:'1%', minWidth:20, templateFn:this._getStatusImage },
            { fieldName:'status', display:'Status', width:'10%', minWidth:50 },
            { fieldName:'comment', display:'Comment', width:'80%', minWidth:300 }
        ]
    };
    _disposalFunctions = [];    //For disposing subscriptions to rxjs observables
    _toEmailAddress = "";


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(casNavBoxService:CASNavBoxService,
                cpdFormatters: CPDFormatters,
                helpers: Helpers,
                webServices:WebServices){

        this.constructor.mapParams(this, arguments);

        // NavBox
        //--------------------
        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => { this.navBoxActionClicked(action); });
        this._disposalFunctions.push(disposer);

    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit(){

        this.setNavBoxActions();
        this.initializeGrowlBox();

        //Load the health check data
        this.webServices.Get({ apiPath:"/healthCheck/getHealthStatus" })
        .then((res)=>{
            console.log("[health-check:ngOnInit() - res:]", res);
            this._gridSettings.rows = res.data;
            //this._gridSettings.loading = false;

            //Add the ping test to grid
            this._doPingTest();
            this.ngOnInit_Complete();

        });
    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {

        this.casNavBoxService.ActionsLoading = false;
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };


    // UI - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {
        if (!action || !action.field_name) { return; }
        switch (action.field_name.toLowerCase()) {

            case "act_test_email":
                this.actionSendTestEmail();
                break;
            //case "act_test_email_template":
            //    this.sendTestEmailTemplate();
            //    break;
        }
        
    };

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked(){
        this._gridSettings.loading = true;

        this.webServices.Get({ apiPath:"/HealthCheck" })
        .then((res)=>{
            console.log("[health-check:gridRefreshClicked() - res:]", res);
            this._gridSettings.rows = res.data;
            this._gridSettings.loading = false;
        });
    };


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // actionSendTestEmail
    //==================================
    actionSendTestEmail() {
        this.addToEmailPopup.Open();
    }

    //==================================
    // _doPingTest
    //==================================
    _doPingTest(){
        
        this.webServices.PublicAPI_Ping("ack")
        .then((res)=>{
            console.log("PublicAPI_Ping", res);
            var newRow = { name: "Public API", status: res.Success ? "alive" : "inactive", comment: "i.e.: InsertDMSTransaction" };
            this._gridSettings.rows.push(newRow);
            this._gridSettings.loading = false;
        })
        .catch((res)=>{
            console.log("PublicAPI_Ping", res);
            var newRow = { name: "Public API", status:"inactive", comment:"Error communicating with PublicAPI: " + res.status };
            this._gridSettings.rows.push(newRow);
            this._gridSettings.loading = false;
        });
        
    };

    //==================================
    // emailAddressValid
    //==================================
    emailAddressValid() {
        return this._toEmailAddress == "" ? true : this.helpers.isValidEmailAddress(this._toEmailAddress);
    }

    //==================================
    // _getStatusImage
    //==================================
    _getStatusImage(data){

        switch(data.toLowerCase()){
            case "alive": return "<div class='mdi mdi-circle' style='color:#36c93f'></div>";
            case "inactive": return "<div class='mdi mdi-circle' style='color:#red'></div>";
            default: return "<div class='mdi mdi-circle' style='color:#e3e038'></div>";
        }

    }

    //==================================
    // initializeGrowlBox
    //==================================
    initializeGrowlBox() {
        // Growl Prep
        //--------------------
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    }

    //==================================
    // sendTestEmail
    //==================================
    sendTestEmail() {

        // Send "" email address, will be set to Test email from config in Email Client
        var emailObj = {
            toEmailAddresses: "",
            subject: "Test Email from CPDES - No Template",
            message: "This is a test email from CPDES (no template)",
            templateName: "",
            templateInput: ""
        };
        this.sendEmail(emailObj);
    }

    //==================================
    // sendTestEmailTemplate
    //==================================
    sendTestEmailTemplate() {

        var templateParameters = ["Test Email Address", "Health Check"];
        // Send "" email address, will be set to Test email from config in Email Client
        var emailObj = {
            toEmailAddresses: this._toEmailAddress,
            subject: "Test Email from CPDES - Using Template",
            message: "",
            templateName: "TestTemplate.html",
            templateInput: templateParameters
        };
        this.sendEmail(emailObj);
    }

    //==================================
    // sendTestEmailTemplate
    //==================================
    sendEmail(emailObj) {

        this.webServices.Post("/email/sendEmail", emailObj)
            .then(res => {
                console.log("[{0}:/email/sendEmail] - res:".format(this._componentName), res);
                if (res.Success) {
                    this.addToEmailPopup.Close();
                    this.growlBox.addGrowl("success", res.DTO + " Email(s) sent successfully.");

                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-EC-SE1":
                            this.growlBox.addGrowl("error", "No email subject provided.");
                            break;

                        case "ERR-EC-SE2":
                            this.growlBox.addGrowl("error", "No email message provided.");
                            break;

                        case "ERR-EC-SE3":
                            this.growlBox.addGrowl("error", "Error sending email message. Mailbox busy or unavailable.");
                            break;

                        case "ERR-EC-SE4":
                            this.growlBox.addGrowl("error", "Failed sending mail to recipient.");
                            break;

                        case "ERR-EC-SE5":
                            this.growlBox.addGrowl("error", "Error sending email message: " + res.ErrorMessage);
                            break;

                        case "ERR-EC-SE6":
                            this.growlBox.addGrowl("error", "Error finding or reading email template.");
                            break;

                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

            });
    }

    //==================================
    // sendButtonClicked
    //==================================
    sendButtonClicked() {
        this.sendTestEmailTemplate();
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        //Mark these as loading until the grid is finished loading 
        this.casNavBoxService.ActionsLoading = true;

        //ACTIONS
        let actions = [];
        actions.push(new FormAction("act_test_email", "Send Test Email"));
        //actions.push(new FormAction("act_test_email_template", "Send Test Email with Template"));

        //Apply the actions        
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;
    };
};
